import { actionTypeKeys } from "./actionTypeKeys";
import { TitleBar } from "../types/titleBar";

export interface SetAppTitleBar {
  type: actionTypeKeys.SET_APP_TITLE_BAR;
  appTitleBar: any;
}

export const setAppTitleBar = (appTitleBar: TitleBar): SetAppTitleBar => {
  return {
    type: actionTypeKeys.SET_APP_TITLE_BAR,
    appTitleBar
  };
};
